import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import * as config from '@/config'
import common from './common'
import message from '@/utils/message'

export default {
  /**
   * 認証処理
   * @param {String} id
   * @param {String} password
   * @param {String} tempKey
   */
  async auth (id, password, tempKey) {
    let heads = {
      'X-API-KEY': store.state.authApiKey
    }
    const data = {
      id: id,
      password: password,
      key: tempKey,
      cookie: config.COOKIE
    }
    const res = await common.apiAxios(config.AUTH_URL, { requireAuthCheck: false, heads: heads, data: data })
    const payload = JSON.parse(window.atob(res.data.token.split('.')[1]))
    store.dispatch({
      type: 'set',
      states: {
        'accountId': id,
        'accountUuid': payload.aid,
        'tempKey': tempKey,
        'token': res.data.token,
        'refreshToken': res.data.refreshToken,
        'apiKey': res.data.apiKey,
        'tokenExp': payload.exp,
        'mfaAuthStatus': payload.mfa
      }
    })
  },
  /**
   * 認証処理
   * @param {String} clientId
   * @param {String} redirectURI
   * @param {String} code
   * @param {String} tempKey
   * @param {String} isACN
   */
  async authSSO (clientId, redirectURI, code, tempKey, isACN) {
    let heads = {
      'X-API-KEY': store.state.authApiKey
    }
    const data = {
      client_id: clientId,
      redirect_uri: redirectURI,
      code: code,
      key: tempKey,
      cookie: config.COOKIE
    }

    // 従業員用のSSO認証である場合、専用のフラグを立てる
    if (isACN) {
      data.isACN = 1
    }

    const res = await common.apiAxios(config.AUTH_SSO_URL, { requireAuthCheck: false, heads: heads, data: data })
    const payload = JSON.parse(window.atob(res.data.token.split('.')[1]))
    store.dispatch({
      type: 'set',
      states: {
        'accountId': res.data.id,
        'accountUuid': payload.aid,
        'tempKey': tempKey,
        'token': res.data.token,
        'refreshToken': res.data.refreshToken,
        'apiKey': res.data.apiKey,
        'tokenExp': payload.exp,
        'mfaAuthStatus': payload.mfa
      }
    })
  },
  /**
   * リフレッシュ処理
   */
  async refresh () {
    const heads = {
      'X-API-KEY': store.state.authApiKey
    }
    let data = { key: store.state.tempKey }
    data.refreshToken = config.COOKIE ? null : store.state.refreshToken
    let res = await common.apiAxios(config.AUTH_TOKEN_URL,
      {
        requireAuthCheck: false,
        heads: heads,
        data: data
      })
    store.dispatch({
      type: 'set',
      states: {
        'token': res.data.token,
        'refreshToken': res.data.refreshToken,
        'tokenExp': JSON.parse(window.atob(res.data.token.split('.')[1])).exp
      }
    })
  },
  /**
   * 認証トークンの有効期限を現在時刻と比較します。
   * @return {Boolean} true: 有効, false: 期限切
   */
  checkTokenExp () {
    // 現在時刻に + 1sec して期限切れを判定
    if (Math.floor(new Date().getTime() / 1000 + 1) > store.state.tokenExp) {
      return false
    }
    return true
  },
  /**
   * トークンの有効期限を確認し、期限切れの場合はリフレッシュを実行します。
   * リフレッシュに失敗した場合、ログイン画面に遷移させます。
   */
  async tokenExpiredTransitionLogin (redirect) {
    if (!this.checkTokenExp()) {
      try {
        Vue.prototype.$loadingService.show()
        await this.refresh()
      } catch (error) {
        store.dispatch({
          type: 'set',
          states: {
            'loggedIn': false
          }
        })
        router.push({ path: store.state.fromAcnLogin ? '/login/acn' : '/login', query: { redirect: redirect || router.history.current.path } })
        common.addError(error, { msg: message.MSG_204(), canIgnore: true })
        throw error
      } finally {
        Vue.prototype.$loadingService.close()
      }
    }
  }
}
